import { render, staticRenderFns } from "./rake-back-skeleton.vue?vue&type=template&id=64d9a74c&scoped=true&lang=pug&"
import script from "./rake-back-skeleton.vue?vue&type=script&lang=js&"
export * from "./rake-back-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./rake-back-skeleton.vue?vue&type=style&index=0&id=64d9a74c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9a74c",
  null
  
)

export default component.exports